import React from 'react';
import PropTypes from 'prop-types';
import { Card, Radio } from '@one-thd/sui-atomic-components';

const SelectableRadioCard = ({ value, selected, disabled, label, children }) => {
  const idBase = `selectable-radio-card-${String(value).replace(/[^A-Za-z0-9_-]/g, '_')}`;
  const radioId = idBase;
  const labelId = `${idBase}-label`;
  const LabelElement = disabled ? 'div' : 'label';
  const labelProps = disabled ? {} : { htmlFor: radioId };

  return (
    <div
      className={
        `sui-mb-4 sui-w-full sui-max-w-full sui-min-w-0 sui-rounded-lg sui-border-solid sui-border-1 sui-overflow-hidden ${
          disabled ? 'sui-border-primary sui-bg-subtle' : 'sui-border-strong'
        }${selected ? ' sui-shadow-sm' : ''}`
      }
    >
      <Card
        variant="shadow"
        grow
        PaperProps={{ shadow: 'none',
          ...(disabled && { className: 'sui-flex sui-rounded-md sui-bg-subtle' })
         }}
        CardContentProps={{ disableGutters: true, disablePadding: true }}
      >
        <div className="sui-p-1 sui-min-w-0">
          <LabelElement
            {...labelProps}
            className={
              `sui-inline-flex sui-items-center sui-w-full sui-min-w-0
              ${disabled ? 'sui-cursor-default' : 'sui-cursor-pointer'}`
            }
          >
            <Radio
              id={radioId}
              value={value}
              disabled={disabled}
              inputAttributes={disabled ? { 'aria-labelledby': labelId } : undefined}
              className={
                'sui-flex sui-justify-center sui-relative sui-box-border sui-bg-transparent '
                + 'sui-align-middle sui-outline-0 sui-border-0 sui-m-0 sui-p-0 sui-select-none '
                + 'sui-appearance-none sui-no-underline sui-items-center sui-shrink-0 '
                + (disabled
                  ? 'sui-cursor-default sui-pointer-events-none [&_svg]:sui-fill-subtle'
                  : 'sui-cursor-pointer sui-tap-highlight-transparent')
              }
            />
            <span
              id={labelId}
              className={
                `sui-pl-1 sui-min-w-0 sui-flex-1 sui-break-all sui-line-clamp-1 sui-text-primary ${
                  selected ? 'sui-font-bold' : 'sui-font-regular'
                }`
              }
            >
              {label}
            </span>
          </LabelElement>
          {selected && children}
        </div>
      </Card>
    </div>
  );
};

SelectableRadioCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.node.isRequired,
  children: PropTypes.node
};

SelectableRadioCard.defaultProps = {
  selected: false,
  disabled: false,
  children: null
};

SelectableRadioCard.displayName = 'SelectableRadioCard';

export { SelectableRadioCard };
